<template>
  <div class="view-login">
    <v-navigation-drawer permanent absolute :width="512">
      <v-container fill-height>
        <v-form
          @submit.prevent="requestLogin"
          v-model="validForm"
          ref="form"
          class="flex-grow-1 d-flex flex-column align-stretch"
        >
          <v-img
            class="align-self-center mb-9"
            src="@/assets/adequation-logo-square.svg"
            :width="250"
            :height="250"
            alt="Adequation"
          />
          <header class="mb-12 text-center">
            <h1 class="display-1">
              {{ $t("Réinitialiser mon mot de passe") }}
            </h1>
          </header>
          <v-alert v-if="status == 'error'" type="error">
            {{ message }}
          </v-alert>
          <v-text-field
            v-model="password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('Mot de passe')"
            hide-details
            filled
            validate-on-blur
            :rules="[rules.required]"
            required
            @click:append="showPassword = !showPassword"
            class="mb-4"
          />
          <v-text-field
            v-model="passwordRepeat"
            :append-icon="showPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPasswordRepeat ? 'text' : 'password'"
            :label="$t('Confirmer mon mot de passe')"
            filled
            :rules="[rules.required, passwordConfirmationRule]"
            required
            @click:append="showPasswordRepeat = !showPasswordRepeat"
            class="mb-4"
          />
          <v-btn
            type="submit"
            :disabled="!validForm"
            :loading="loading"
            color="primary"
            large
            rounded
            class="align-self-center mb-9"
            >{{ $t("Réinitialiser mon mot de passe") }}</v-btn
          >

          <div class="env" :class="env">
            <div>{{ env }}</div>
          </div>
        </v-form>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { SET_PASSWORD, ADD_SNACKBAR, CHECK_TOKEN } from "@/store/action-types";
const { mapActions: mapAuthActions } = createNamespacedHelpers(`auth`);

const { mapActions: mapAppActions } = createNamespacedHelpers(`app`);

export default {
  data() {
    return {
      env: process.env.VUE_APP_API_ENV,
      loading: false,
      token: this.$route.query.token || null,
      validForm: false,
      password: "",
      passwordRepeat: "",
      showPassword: false,
      showPasswordRepeat: false,
      status: null,
      message: null,
      rules: {
        required: value => !!value || this.$t("Requis."),
        equal: value => value == this.password
      }
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.password === this.passwordRepeat ||
        this.$t("Les mots de passe ne sont pas identiques");
    }
  },
  beforeMount() {
    if (!this.token) {
      this.redirectToLogin();
    }
    //Check token
    this.checkToken({
      token: this.token
    })
      .then(res => {
        //200 : ras
        if (res.status >= 200 && res.status < 300) {
          //do nothing
        }
        //401 : redirection resetpassword + message d'erreur (message dans le store)
        else if (res.status == 401) {
          this.redirectToResetPassword();
        }
        //!200 & !401 -> "contact administrator"
        else {
          this.message = this.$t(
            "Une erreur a eu lieu. \n Veuillez contacter l'administrateur contact@adequation-france.com."
          );
          this.status = "error";
        }
      })
      .catch(() => {
        this.message = this.$t(
          "Une erreur a eu lieu. \n Veuillez contacter l'administrateur contact@adequation-france.com."
        );
        this.status = "error";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapAuthActions({
      setPassword: SET_PASSWORD,
      checkToken: CHECK_TOKEN
    }),
    ...mapAppActions({
      addSnackbar: ADD_SNACKBAR
    }),
    requestLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        this.setPassword({
          password: this.password,
          passwordRepeat: this.passwordRepeat,
          token: this.token
        })
          .then(res => {
            if (res.status >= 200 && res.status < 300) {
              this.redirectToLogin();
              this.addSnackbar({
                message: this.$t("Mot de passe mis à jour.")
              });
            } else {
              this.message = this.$t(
                "Une erreur a eu lieu. Veuillez réessayer."
              );
              this.status = "error";
            }
          })
          .catch(() => {
            this.message = this.$t(
              "Une erreur a eu lieu. \n Veuillez contacter l'administrateur contact@adequation-france.com."
            );
            this.status = "error";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    redirectToLogin() {
      this.$router.push({ name: "login" });
    },
    redirectToResetPassword() {
      this.$router.push({
        path: "reset-password",
        query: { token: this.token }
      });
    }
  }
};
</script>

<style lang="scss">
.view-login {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url("~@/assets/login-background.jpg") no-repeat center right/cover;
}

.error {
  white-space: pre-line;
}

.env {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255, 255, 255);
  height: 96px;
  width: 96px;
  border-radius: 50%;

  position: absolute;
  left: 8px;
  bottom: 8px;
}

.LOCAL {
  background-color: #1ab5a9;
  opacity: 0.8;
}
.DEV,
.RCT {
  background-color: #4955bb;
  opacity: 0.8;
}
.PROD {
  background-color: rgb(255, 255, 255);
  visibility: hidden;
}
</style>
